import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FilterComponent } from "../../components/filters";
import { Breadcrumbs } from "../../components/partial/Breadcrumbs";
import Pagination from "../../components/pagination";
import debounce from "lodash.debounce";
import * as qs from "query-string";
import { ApiRoutes, AppRoutes } from "../../../config";
import { ApiHelper } from "../../../helpers";
import { toast } from "react-toastify";
import { TransactionsListComponent } from "../../components/TransactionsListComponent/TransactionsListComponent";
import { SearchFilter } from "../../components/filters/searchFilter";

class Transactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: [],
      isLoading: false,
      totalRecords: 0,
      currentPage: 1,
      limit: 10,
      deleteError: false,
      sortBy: "createdAt",
      search: "",
      order: "desc",
      sortByStatus: "all",
    };
    this.emitSearch = debounce(this.onSearch, 200);
  }
  componentDidMount = () => {
    this.handleQueryParams();
  };

  handleQueryParams = () => {
    const {
      location: { search },
    } = this.props;

    const query = qs.parse(search);
    this.setState(
      {
        currentPage: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 10,
        search: query.search || "",
        sortBy: query.sortBy || "all",
        sortByStatus: query.status || "all",
        order: query.order || "asc",
      },
      () => this.getTransaction()
    );
  };

  componentDidUpdate = ({ location: { search: prevSearch } }) => {
    const {
      location: { search },
    } = this.props;
    if (prevSearch !== search) {
      this.handleQueryParams();
    }
  };

  getTransaction = async () => {
    const { currentPage, limit, sortBy, search, order, sortByStatus } =
      this.state;
    let skip = limit * (currentPage - 1);
    let data = {
      skip,
      limit,
      sortBy,
      search,
      order,
      sortByStatus,
    };
    if (search && this.state.isLoading) {
      new ApiHelper().cancelRequest("cancel");
    }
    this.setState({
      isLoading: true,
    });
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.GET_TRANSACTION.service,
      ApiRoutes.GET_TRANSACTION.url,
      ApiRoutes.GET_TRANSACTION.method,
      ApiRoutes.GET_TRANSACTION.authenticate,
      data,
      undefined
    );
    this.setState({
      isLoading: false,
    });
    console.log(response);
    if (response && response.isError) {
      toast.error(response.messages[0]);
    } else {
      this.setState({
        transactions: response.data.data,
      });
      this.setState({
        totalRecords: response.data.count,
      });
    }
  };

  onPageChanged = (page) => {
    const { currentPage } = this.state;
    if (page !== currentPage) {
      const {
        location: { search, pathname },
      } = this.props;
      const query = qs.parse(search);
      this.props.history.push(
        [pathname, qs.stringify({ ...query, page })].join("?")
      );
    }
  };

  onLimitChange = (limit) => {
    const {
      location: { search, pathname },
    } = this.props;
    const query = qs.parse(search);
    this.props.history.push(
      [pathname, qs.stringify({ ...query, page: 1, limit })].join("?")
    );
  };

  // To handle search on typing
  handleSearch = (event) => {
    const {
      target: { name, value },
    } = event;
    this.setState({ [name]: value });
    event.persist();
    this.emitSearch();
  };

  onSearch = () => {
    const { search } = this.state;
    const {
      props: {
        location: { search: searchParam, pathname },
      },
    } = this;
    const query = qs.parse(searchParam);
    let params = {};
    params.page = 1;
    params.search = search;
    this.props.history.push(
      [pathname, qs.stringify({ ...query, ...params })].join("?")
    );
  };

  setFilter = (sortBy, name) => {
    const {
      props: {
        location: { search: searchParam, pathname },
      },
    } = this;
    const query = qs.parse(searchParam);
    let params = {};
    params.page = 1;
    if (sortBy) {
      params[name] = sortBy;
    }
    this.props.history.push(
      [pathname, qs.stringify({ ...query, ...params })].join("?")
    );
    this.setState({
      dropdownOpen: false,
      dropdownId: "",
    });
  };
  setSortFilter = (sortBy, order) => {
    const {
      props: {
        location: { search: searchParam, pathname },
      },
    } = this;
    const query = qs.parse(searchParam);
    let params = {};
    params.page = 1;
    if (sortBy) {
      params.sortBy = sortBy;
    }

    if (order) {
      params.order = order;
    }

    this.props.history.push(
      [pathname, qs.stringify({ ...query, ...params })].join("?")
    );
  };

  viewTransaction = (value) => {
    console.log(value);
    this.props.history.push(
      AppRoutes.TRANSACTIONSVIEW.replace(":id", value._id)
    );
  };
  render() {
    const {
      sortBy,
      search,
      transactions,
      isLoading,
      order,
      currentPage,
      limit,
      totalRecords,
      sortByStatus,
    } = this.state;
    const {
      props: {
        location: { pathname },
      },
    } = this;

    const filterOption = [
      { label: "All", value: "all" },
      { label: "Transaction ID", value: "transaction" },
      { label: "Plan Name", value: "planName" },
      { label: "Client Name", value: "clientName" },
      { label: "Date & Time", value: "transactionDate" },
      { label: "Status", value: "status" },
    ];
    const filtersOptionStatus = [
      {
        label: "All",
        value: "all",
      },
      {
        label: "Successful",
        value: "Successful",
      },
      {
        label: "Failed",
        value: "Failed",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    return (
      <>
        <div className="container-fluid fluid-pd-2">
          <h1 className="h3-head-mob d-md-none">Plan Listing</h1>
          <Breadcrumbs pathname={pathname} />
          <div className="card card-main card-pagination transactionListingCard">
            <div className="card-header  py-7550  align-items-center justify-content-between">
              <div className="row">
                <div className="col-md-3 head-cat-col-lg">
                  <h6 className="font-book">Transaction Listing</h6>
                </div>
                <div className="col-md-9 action-col-lg ">
                  <div className="dp-right d-flex align-items-center customWidthSearchbar">
                    <SearchFilter
                      id={"sm-search-filter"}
                      placeholder={
                        "Search by Plan Name, Client Name and Description"
                      }
                      search={search}
                      onChange={this.handleSearch}
                    />
                    {/* <FilterComponent
                      options={filterOption}
                      selectedFilter={sortBy}
                      onFilterChange={this.setFilter}
                    />
                    <FilterComponent
                      options={filterOption}
                      selectedFilter={sortBy}
                      onFilterChange={this.setFilter}
                    /> */}
                    <FilterComponent
                      label={"Sort By"}
                      options={filterOption}
                      selectedFilter={sortBy}
                      onFilterChange={(selectedValue) =>
                        this.setFilter(selectedValue, "sortBy")
                      }
                    />
                    <FilterComponent
                      label={"Status"}
                      options={filtersOptionStatus}
                      selectedFilter={sortByStatus}
                      onFilterChange={(selectedValue) =>
                        this.setFilter(selectedValue, "status")
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <TransactionsListComponent
              setFilter={this.setSortFilter}
              transactions={transactions}
              isLoading={isLoading}
              order={order}
              sortBy={sortBy}
              viewTransaction={this.viewTransaction}
            />
          </div>
          <div className="footer-pg">
            {!isLoading ? (
              <>
                <div className="float-left mt-2">
                  <p className="page-desc-left">
                    Total: <span className="bold-black">{totalRecords}</span>
                  </p>
                </div>
                <div className="float-right mt-2">
                  {totalRecords > limit ? (
                    <div className="float-right ">
                      <Pagination
                        totalRecords={totalRecords}
                        currentPage={currentPage}
                        pageLimit={limit}
                        onPageChanged={this.onPageChanged}
                      />
                    </div>
                  ) : null}
                </div>
              </>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

export default Transactions;
